import axios from 'axios-observable';
import type { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { CORE_SERVICES_API_URL } from 'config/constants';

const coreServicesApiUrl = `${CORE_SERVICES_API_URL}/v2/store`;

export const getAppPermission = (): AxiosObservable<any> => {
  return axios.get(`${coreServicesApiUrl}/apps`);
};
